(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-experience"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
    // Configure/customize these variables.
    var showChar = 820;  // How many characters are shown by default
    var ellipsestext = "...";
    var moretext = '<a href="javscript:avoid(0);" class="btn-more webp-png-formate">read more</a>';
    var lesstext = '<a href="javscript:avoid(0);" class="btn-more webp-png-formate">read less</a>';


    $('.more').each(function() {
        var content = $(this).html();

        if(content.length > showChar) {

            var c = content.substr(0, showChar);
            var h = content.substr(showChar, content.length - showChar);

            var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<div class="morelink">' + moretext + '</div></span>';

            $(this).html(html);
        }

    });

    $(".morelink").click(function(){
        if($(this).hasClass("less")) {
            $(".morelink").removeClass("less");
            $(".morelink").html(moretext);
        } else {
            $(".morelink").addClass("less");
            $(".morelink").html(lesstext);
        }
        $(".morelink").parent().prev().toggle();
        $(".morelink").prev().toggle();
        return false;
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
 $('.gallery-pop').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      mainClass: 'mfp-img-mobile',
      image: {
        verticalFit: true
      }

    });

  } catch(e) { console.error(e); }
})();
})();
